<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhtsgbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'古籍数字化平台'" ></detailBread>
        <div class="container">
            <div class="page-title">
                古籍数字化平台
            </div>
            <div class="page-content">
                <img src="../../../static/images/zhtsg-gjszhpt-01.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '古籍数字化平台', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '古籍数字化平台'
        },
        {
            name: 'description',
            content: '古籍数字化平台'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'2',
            blackTabsNum:'3'
        }
    },
    methods: {
        topback(){
            window.localStorage.setItem('blackTabsNum',3)
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/old/gjszhpt.vue